/**
 * Plan definitions and limits.
 *
 * All subscription management is handled by Stripe (future).
 * For now every user is on the free plan.
 */

export type PlanName = 'free' | 'pro';

export interface PlanLimits {
  /** Maximum number of projects/waitlists the user may create. */
  maxProjects: number;
  /** Maximum number of subscribers per project. */
  maxSubscribers: number;
  /** Whether webhooks are available. */
  webhooks: boolean;
  /** Whether Slack integration is available. */
  slack: boolean;
  /** Whether API key management is available. */
  apiKeys: boolean;
  /** Whether domain protection is available. */
  domainProtection: boolean;
}

export const PLANS: Record<PlanName, PlanLimits> = {
  free: {
    maxProjects: 1,
    maxSubscribers: 100,
    webhooks: false,
    slack: false,
    apiKeys: false,
    domainProtection: false,
  },
  pro: {
    maxProjects: Infinity,
    maxSubscribers: Infinity,
    webhooks: true,
    slack: true,
    apiKeys: true,
    domainProtection: true,
  },
};
